import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseEventMessage } from 'entities/Message'

export function useEventMessageReceivedNewGlobal(
  handler: (response: IResponseEventMessage) => void,
  deps: unknown[] = []
) {
  const entities = useEntitiesContext()
  const _handler = (response: IResponseEventMessage) => {
    const normalizeResponse: IResponseEventMessage = {
      ...response,
      conversation: {
        ...response.conversation,
        contact: response.contact || response.conversation.contact,
      },
    }
    handler(normalizeResponse)
  }

  useEffect(() => entities.websocket.on(WebsocketEvent.MessageReceivedNew, _handler), deps)
}
